import { Injectable } from '@angular/core';

import { SkyResources } from './resources';


export class SkyResourcesService {
  public getString(name: string): string {
    return SkyResources.getString(name);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
